import { readPref, writePref } from "./prefs.ts";

// The product the sidebar and its pages show (docs/design-system.md §0.2):
// remembered on this device, and announced so the sidebar follows a page that
// opened another product. Without browser storage it lasts until a reload.

const EVENT = "zooi:product";
let memory: string | null = null;

export const lastProduct = (): string | null => readPref("last-product") ?? memory;

export function rememberProduct(id: string) {
  if (lastProduct() === id) return;
  memory = id;
  writePref("last-product", id);
  if (typeof window !== "undefined") window.dispatchEvent(new Event(EVENT));
}

/** For `useSyncExternalStore`: changes here, and in another tab of this browser. */
export function subscribeProduct(listener: () => void) {
  window.addEventListener(EVENT, listener);
  window.addEventListener("storage", listener);
  return () => {
    window.removeEventListener(EVENT, listener);
    window.removeEventListener("storage", listener);
  };
}
